import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

export default function RequireAuth({ component: Component, ...props }) {
  const token = useSelector((state) => state.userSession?.token);
  if (!token) {
    const target =
      `${props.location?.pathname || '/'}` +
      `${props.location?.search || ''}` +
      `${props.location?.hash || ''}`;

    return (
      <Redirect
        to={`/login?return_url=${encodeURIComponent(target)}`}
      />
    );
  }

  return <Component {...props} />;
}
